export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

type DemoRole = 'ai' | 'user';

type DemoItem = {
    key: number
    role: DemoRole
    content: string
};

interface Props {
    roles: Record<DemoRole, any>
    items: DemoItem[]
    nextKey: number
}

const replies = [
    '我已经收到，我们可以继续把这段对话补充完整。',
    '这里追加了一条新的回复，列表会在底部附近时自动贴底。',
    '如果用户已经手动上滑，BubbleList 会尊重阅读位置，不会强行拉回。',
    '每条消息都带稳定 key，后续滚动定位和流式更新会更可靠。',
];

function createRoles(): Props['roles'] {
    return {
        ai: {
            placement: 'start',
            avatar: true,
            roleName: 'AI 助手',
            variant: 'plain',
        },
        user: {
            placement: 'end',
            avatar: true,
            roleName: '我',
            shape: 'corner',
        },
    };
}

function createMessage(key: number): DemoItem {
    const isUser = key % 2 === 1;

    return {
        key,
        role: isUser ? 'user' : 'ai',
        content: isUser ? `继续补充第 ${key} 条问题。` : replies[(key / 2 - 1) % replies.length],
    };
}

function createState(): Props {
    return {
        roles: createRoles(),
        items: [
            {
                key: 1,
                role: 'user',
                content: '先帮我搭一段两条消息的对话。',
            },
            {
                key: 2,
                role: 'ai',
                content: '好的，初始对话已经准备好了，可以继续追加新的消息。',
            },
        ],
        nextKey: 3,
    };
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return createState();
    }

    @bind
    appendMessage() {
        const nextKey = this.get('nextKey');

        this.set({
            items: this.get('items').concat(createMessage(nextKey)),
            nextKey: nextKey + 1,
        });
    }
}